const LANG_FALLBACK = { en: 'English', it: 'Italian' };

export const getLangInstruction = (lang = 'en') => {
  const fallback = LANG_FALLBACK[lang] ?? 'English';
  return `LANGUAGE: respond in the same language as the node content. If you cannot determine the language, use ${fallback} as fallback.`;
};

export const getQuizOpenSystemPrompt = (lang = 'en') => `You are an expert tutor in active learning on concept maps.
Generate ONE open-ended question that tests deep understanding of a concept.

OUTPUT FORMAT:
Return ONLY valid JSON with these keys:
{
  "question": "the open question",
  "answer": "concise model answer"
}

RULES:
1. The question requires an articulated answer (not yes/no, not fill-in-the-blank).
2. "question" brief: 8-20 words.
3. "answer" is the ideal response: clear, precise, 25-55 words.
4. No markdown, no extra text outside the JSON.

${getLangInstruction(lang)}`;

const buildContext = (neighbors = []) =>
  neighbors
    .slice(0, 4)
    .map((n, i) => `${i + 1}) ${n.title}`)
    .join('\n') || 'nessuno';

export const constructQuizOpenPrompt = (node, neighbors = [], rootNode = null) => {
  const mapTopic =
    rootNode && rootNode.id !== node.id
      ? `\nMAPPA: "${rootNode.title}"${rootNode.summary ? ` — ${rootNode.summary}` : ''}`
      : '';

  return `${mapTopic}
NODO: "${node.title}"
SUMMARY: "${node.summary || ''}"
NOTE: "${node.description || ''}"
CONCETTI COLLEGATI:
${buildContext(neighbors)}

Genera una domanda aperta che testi la comprensione profonda di questo concetto nel contesto della mappa.`;
};

export const parseQuizOpenResponse = (response, fallbackNode) => {
  try {
    const raw = response.replace(/```(?:json)?/g, '').trim();
    const start = raw.indexOf('{');
    const end = raw.lastIndexOf('}');
    const parsed = JSON.parse(raw.slice(start, end + 1));
    return {
      question: (parsed.question || '').trim() || `Spiega il concetto: ${fallbackNode.title}`,
      answer: (parsed.answer || '').trim() || fallbackNode.summary || fallbackNode.title,
    };
  } catch {
    return {
      question: `Spiega il concetto: ${fallbackNode.title}`,
      answer: fallbackNode.summary || fallbackNode.description || fallbackNode.title,
    };
  }
};
